import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemSection } from './components/SystemSection';
import { MapProof } from './components/MapProof';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { FitSection } from './components/FitSection';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-night font-sans text-parchment" data-id="element-0" data-mp="3ijxsgzk2wgo4">
      <noscript data-id="element-1" data-mp="3ijpc2xoqyt86">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ii4sg33z0up3" />
      </noscript>
      <Hero data-id="element-3" data-mp="5os92t1uy7l" />
      <main data-id="element-4" data-mp="67yhm9c7y5s">
        <PainPoints data-id="element-5" data-mp="4ww9qvjiygs" />
        <SystemSection data-id="element-6" data-mp="56nfhsbnbo2" />
        <MapProof data-id="element-7" data-mp="7stfczkdj46" />
        <WhatsIncluded data-id="element-8" data-mp="2zld1r8m3ndb0" />
        <Bonuses data-id="element-9" data-mp="2zm4zaoz9bl3x" />
        <OfferStack data-id="element-10" data-mp="2zmo4d53t6f0j" />
        <FitSection data-id="element-11" data-mp="2zn6cayzu2hoa" />
        <Testimonials data-id="element-12" data-mp="33moqzd129wio" />
        <Pricing data-id="element-13" data-mp="33lwzadal4ixo" />
        <Guarantee data-id="element-14" data-mp="33nggc642ey0i" />
        <Faq data-id="element-15" data-mp="33myl9ct52pu6" />
        <FinalCta data-id="element-16" data-mp="33oi2b5mmd4x0" />
      </main>
      <Footer data-id="element-17" data-mp="38l8gtoirzsgb" />
      <StickyCta data-id="element-18" data-mp="38kqc03i1s5ws" />
      <PurchaseToast data-id="element-19" data-mp="38k6ugnwb7jja" />
    </div>;
}